import React from 'react';

import { permissions } from '@vlabs/shared/config';
import { routes } from '@vlabs/shared/navigation/routes';
import { useSelector } from 'react-redux';

import { viewerCan } from '@vlabs/pages/auth/selectors';
import { selectVaStreamOptions } from '@vlabs/pages/video-analytics/selectors';

import { StreamLinkBase } from './StreamLinkBase';

export const AnalyticStreamLink = ({ streamId, ...props }) => {
  const streamOptions = useSelector(selectVaStreamOptions);
  const canView = useSelector((state) => viewerCan(state)([permissions.source.view]));
  const stream = streamOptions.find((s) => s.streamId === streamId);

  return (
    <StreamLinkBase
      canView={canView}
      route={routes.videoAnalytics.streams.edit}
      stream={stream}
      streamId={streamId}
      {...props}
    />
  );
};
